export default {
    'PREQUESTION.TITLE': 'You are selecting a time slot more than 10 days from now. Is it at the client’s request?',
};
